import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { TranscriptViewerComponent } from './transcript-viewer.component';

// TODO - remove when feedbackSession ngx STAB-680
export { TranscriptViewerModule } from './transcript-viewer.module';
export const ngxTranscriptViewerModule = angular.module('ngxTranscriptViewerModule', [])
	.directive('ngxTranscriptViewer', downgradeComponent({component: TranscriptViewerComponent}))
	.name;
